import React from "react"
import { useTranslation } from "react-i18next"
import GetEnvironment from "../../enviroments"
import { ProjectCreatedWithStatus } from "../../types"
import { ConfigStatus } from "./ConfigMain"
import { ProgressBanner } from "./ProgressBanner"
import UserPermissionsModal from "./UserPermissionsModal"

// Contains the button and the progress banner
const QuadriHeader = (props: {
  configStatus: ConfigStatus
  isEnableButtonDisabled?: boolean
  statusMessage?: string
  updateErrorMessage?: string
  createProjectResponse: any
  submitQuadriProject: (e: any) => void
  createdAt?: string
  updatedAt?: string
  permissionsUpdatedAt?: string
  projectCreatedWithStatus?: ProjectCreatedWithStatus
}) => {
  const { configStatus, isEnableButtonDisabled, createdAt, updatedAt, permissionsUpdatedAt } = props
  const { statusMessage, createProjectResponse, submitQuadriProject } = props
  const { updateErrorMessage, projectCreatedWithStatus } = props
  const [showUserPermissionsModal, setShowUserPermissionsModal] = React.useState(false)
  const showModal = () => setShowUserPermissionsModal(true)
  const closeModal = () => window.location.reload()

  const { t } = useTranslation("config")

  const onClickUserPermissions = showModal
  return (
    <div className="row">
      <div className="col-12 head-container mt-1">
        <div className="page-heading mt-0">
          <h1>{t("quadriHeader.title")}</h1>
          {GetEnvironment().showUserPermissions && (
            <button
              className="button secondary mr-1 ml-auto"
              onClick={onClickUserPermissions}
              disabled={isEnableButtonDisabled || configStatus !== "Active"}
            >
              {t("quadriHeader.userPermissions")}
            </button>
          )}
          {showUserPermissionsModal && <UserPermissionsModal closeModal={closeModal} />}
          <QuadriActionButton
            configStatus={configStatus}
            isButtonDisabled={isEnableButtonDisabled}
            submitQuadriProject={submitQuadriProject}
          />
        </div>
      </div>

      {(configStatus === "Creating" || configStatus === "Active" || configStatus === "Failed") && (
        <ProgressBanner
          retryProcess={submitQuadriProject}
          configStatus={configStatus}
          errorMessage={statusMessage || createProjectResponse.error?.message}
          updateErrorMessage={updateErrorMessage}
          disableRetry={isEnableButtonDisabled}
          createdAt={createdAt}
          updatedAt={updatedAt}
          permissionsUpdatedAt={permissionsUpdatedAt}
          projectCreatedWithStatus={projectCreatedWithStatus}
        />
      )}
    </div>
  )
}

const QuadriActionButton = (props: {
  configStatus: ConfigStatus
  isButtonDisabled?: boolean
  submitQuadriProject: (e: any) => void
}) => {
  const { configStatus, isButtonDisabled, submitQuadriProject } = props
  const { t } = useTranslation("config")
  return (
    <button
      className={configStatus === "Creating" ? "button primary icon-left" : "button primary"}
      onClick={submitQuadriProject}
      disabled={isButtonDisabled}
      title={configStatus === "Active" ? t("quadriHeader.updateTooltip") : undefined}
    >
      {configStatus === "Updating" ? (
        <>
          <i className="icon-font tc-icon-spinner-light"></i>
          {t("quadriHeader.updatingQuadri")}
        </>
      ) : configStatus === "Creating" ? (
        <>
          <i className="icon-font tc-icon-spinner-light"></i>
          {t("quadriHeader.enablingQuadri")}
        </>
      ) : configStatus === "Active" ? (
        t("quadriHeader.update")
      ) : (
        t("quadriHeader.saveAndEnable")
      )}
    </button>
  )
}

export default QuadriHeader
